/** Premium tabs gated behind /agentic/features email allowlist (Import + Agentic). */

export const IMPORT_TAB_ID = "import";
export const AGENTS_TAB_ID = "agents";

/** @deprecated Use IMPORT_TAB_ID */
export const LEGACY_IMPORT_TAB_ID = "agentic";

export const PUTS_PLUS_TAB_ID = "puts-plus";
export const CALLS_PLUS_TAB_ID = "calls-plus";

export const GATED_TAB_IDS = new Set([IMPORT_TAB_ID, AGENTS_TAB_ID, PUTS_PLUS_TAB_ID, CALLS_PLUS_TAB_ID]);

/** Normalize persisted tab ids from older builds. */
export function normalizeTabId(id: string): string {
  return id === LEGACY_IMPORT_TAB_ID ? IMPORT_TAB_ID : id;
}

export function isGatedTabId(id: string): boolean {
  return GATED_TAB_IDS.has(normalizeTabId(id));
}

/** @deprecated Prefer isGatedTabId */
export function isAgenticTabId(id: string): boolean {
  return isGatedTabId(id);
}

let agenticEnabled: boolean | null = null;
let robinhoodEnabled: boolean | null = null;

export async function loadAgenticFeatureFlag(force = false): Promise<boolean> {
  if (!force && agenticEnabled !== null) return agenticEnabled;
  try {
    const res = await fetch("/agentic/features", {
      method: "GET",
      credentials: "include",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) {
      agenticEnabled = false;
      robinhoodEnabled = false;
      return false;
    }
    const payload = (await res.json()) as { enabled?: boolean; robinhood?: boolean };
    agenticEnabled = Boolean(payload.enabled);
    robinhoodEnabled = payload.robinhood === true || agenticEnabled === true;
    return agenticEnabled;
  } catch {
    agenticEnabled = false;
    robinhoodEnabled = false;
    return false;
  }
}

export function isAgenticFeatureEnabled(): boolean {
  return agenticEnabled === true;
}

/** Per-login Robinhood connection and closed-market feed. Separate from the Agents tab. */
export function isRobinhoodIntegrationEnabled(): boolean {
  return robinhoodEnabled === true;
}

export function resetAgenticFeatureFlag(): void {
  agenticEnabled = null;
  robinhoodEnabled = null;
}

export function filterAgenticTab<T extends { id: string }>(definitions: T[]): T[] {
  if (isAgenticFeatureEnabled()) return definitions;
  return definitions.filter((tab) => !isGatedTabId(tab.id));
}
